
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import { agentTableFieldsFull, agentTableFieldsMinimal } from '@/app/components/agent/tableFields/agentTableFields';
import AddIndividualModal from '@/app/components/individual/AddIndividualModal.vue';
import { Individual, IndividualType } from 'ah-api-gateways';
import IndividualInfo from '@/app/components/individual/IndividualInfo.vue';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import IndividualListing from '@/app/components/individual/IndividualListing.vue';
import {
  companyMemberTableFieldsFull,
  companyMemberTableFieldsMinimal,
} from '@/app/components/individual/tableFields/companyMemberTableFields';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    IndividualListing: IndividualListing,
    IndividualInfo,
    AddIndividualModal,
    InfoTooltip,
  },
})
export default class PartnerMembersSettingsView extends Vue {
  $refs!: {
    individualListing: IndividualListing;
  };

  @Prop({ required: false }) memberId?: string;

  // Auto-set by AnimatedListingWithSubView[animatedState.sync] in template
  private animatedState: AnimatedListingWithSubViewState | null = null;

  get authStore() {
    return useAuthStore();
  }

  get individualsFilter() {
    if (this.authStore.isAgent) {
      return {
        type: [IndividualType.PARTNER_ADMIN, IndividualType.PARTNER_AGENT],
      };
    } else {
      return {
        type: [IndividualType.CLIENT_ADMIN, IndividualType.CLIENT_INDIVIDUAL],
      };
    }
  }

  get memberTableConfig() {
    if (this.authStore.isAgent) {
      return this.$mediaQuery.is('mdDown') && !this.animatedState?.wideList
        ? { tableFields: agentTableFieldsMinimal }
        : { tableFields: agentTableFieldsFull };
    } else {
      return this.$mediaQuery.is('mdDown') && !this.animatedState?.wideList
        ? { tableFields: companyMemberTableFieldsMinimal }
        : { tableFields: companyMemberTableFieldsFull };
    }
  }

  onIndividualUpdated() {
    this.$refs.individualListing.loadData();
  }

  onIndividualDeleted() {
    this.gotoMember();
    if (this.$refs.individualListing) {
      this.$refs.individualListing.loadData();
    }
  }

  gotoMember(agent?: Individual) {
    if (!agent || this.memberId === agent.id) {
      this.$router.push({ path: '..', append: true });
    } else {
      if (this.memberId) {
        this.$router.push({ path: `../${agent.id}`, append: true });
      } else {
        this.$router.push({ path: agent.id, append: true });
      }
    }
  }
}
